// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17k0f","right":"styles_right__1eMZd"};